import React, {Component} from 'react';
import * as InitStatus from "../../../constants/common/InitializationStatus";
import InflowProcessBar from "../common/InflowProcessBar";
import {connect} from "react-redux";
import autobind from "autobind-decorator";
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {addPrefix} from "../../../utils/UriUtil";
import {assignDataByDefault, copyInflowData, hasRef} from "../common/InflowData";
import {checkEarlierThanCreationDate, getSearchEngineStrokeColorByService} from "../common/CommonHelper";
import {InflowTopLayerButton} from "../common/InflowTopLayer";
import InflowDevice from "../common/InflowDevice";


@connect(state => ({
  pv: state.statistics.pv,
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
  minDate: state.statistics.minDate,
}), dispatch => ({dispatch}))
class BlogInflow extends Component {

  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
    this.processTimer = null;
    this.processDefaultTimer = null;
  }

  // 초기 state
  getDefaultState() {
    return {
      initialized: InitStatus.INIT_READY,
      inflowData: copyInflowData(),
      isLayerOpen: false
    };
  }

  // Unmount전에 timer을 clear한다.
  componentWillUnmount() {
    if (this.processTimer) clearTimeout(this.processTimer);
    if (this.processDefaultTimer) clearTimeout(this.processDefaultTimer);
  }


  // 데이터 변경여부를 Watching한다.
  shouldComponentUpdate(nextProps, nextState) {
    if (this.checkIsChangedActiveDateOrType(nextProps)) {
      this.getInflowData(nextProps);
    }
    return true;
  }

  // 날짜, 타입 변경 여부
  @autobind
  checkIsChangedActiveDateOrType(nextProps) {
    const {activeDate, activeDateType} = this.props;
    return activeDate !== nextProps.activeDate || activeDateType !== nextProps.activeDateType;
  }


  // 상세유입정보 호출
  @autobind
  getInflowData(nextProps) {
    const {activeDate, activeDateType, minDate, dispatch} = nextProps;
    const isEarlierThanCreationDate = checkEarlierThanCreationDate(activeDateType, activeDate, minDate);

    // process가 0부터 시작해야되기 때문에 state가 완료후 데이터를 로드한다. 또한 데이터 변화 시점을 맞추기위해 최소 interval을 제공한다.
    this.setState({...this.getDefaultState(), initialized: InitStatus.INIT_DOING}, () => {

      if (this.processTimer != null) clearTimeout(this.processTimer);

      this.processTimer = setTimeout(() => {
        fetch(addPrefix(`/manage/statistics/blog/${activeDate}/${activeDateType}/inflow.json`), {
          credentials: 'include',
          headers: {'Content-Type': 'application/json'},
          retries: 2,
          retryDelay: 300,
          retryOn: [500],
        })
          .then(jsonResponseHandler(dispatch))
          .then(res => res.json())
          .then(res => {
            const data = res.data;
            const result = data && data.hasOwnProperty('result') ? data.result : null;

            this.setState({
              initialized: InitStatus.INIT_SUCCESS,
              inflowData: assignDataByDefault(result, isEarlierThanCreationDate)
            })
          })
          .catch(e => {
            console.error(e);
            alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
            this.setState({initialized: InitStatus.INIT_FAIL});
          })
      }, 500)
    });
  }

  render() {
    const {inflowData, initialized, isLayerOpen} = this.state;
    const {isDoing} = InitStatus.init(initialized, null);
    const {searchEngine, sns, ref, deviceType} = inflowData;
    const disableBtn = !hasRef(ref.list);
    const searchStrokeColor = getSearchEngineStrokeColorByService();

    return (
      <div className="statistic_content">
        {isDoing && <Loading/>}
        <InflowProcessBar data={searchEngine} lineColor={searchStrokeColor}/>
        <InflowProcessBar data={sns} lineColor="#00C3A9"/>
        <InflowProcessBar data={ref} lineColor="#9BA5AF">
          <InflowTopLayerButton
            isLayerOpen={isLayerOpen}
            disableBtn={disableBtn}
            refType={"blog"}
          />
        </InflowProcessBar>
        <InflowDevice data={deviceType}/>
      </div>
    );
  }
}

function Loading() {
  return <div className="date_loading date_loading_type1">
    <div className="inner_g">
      <span className="ico_blog ico_loading">로딩중입니다.</span>
    </div>
  </div>
}

export default BlogInflow;
